import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoginService } from '../login/service/login.service';
import { SettingsService } from '../../views/layout/settings/service/settings.service';
import { MainService } from '../../views/layout/main/service/mainservice';
import { DashboardService } from '../../views/layout/dashboard/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Input() userDetails: any;
  caption: any;
  title: any;
  logo: any;
  logoData: boolean = false;
  appsList: any[] = [];
  appsListNormal: any[] = [];
  myOptions: any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };
  selectedApp: any = '';
  allowedApps: any[] = [];
  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly service: LoginService,
    private readonly settingService: SettingsService,
    private readonly mainService: MainService,
    private readonly dashboardService: DashboardService,
  ) {}

  ngOnInit() {
    this.dashboardService.getCurrentUser().subscribe({
      next: (response: any) => {
        sessionStorage.setItem('loggedInUser', response?.id?.toString());
        sessionStorage.setItem(
          'clientId',
          response?.client_id?.[0]?.toString(),
        );
        sessionStorage.setItem('roleId', response?.role_id?.toString());
        this.allowedApps = response['apps'];
        this.appsList = [
          {
            text: 'Post Call',
            icon: 'bi bi-headset',
            url: '/main/postcall/audioRecords',
            name: 'audio',
            active: this.isAllowed('Call'),
          },
          {
            text: 'Voice Mail',
            icon: 'bi bi-voicemail',
            url: '/main/voiceMailRecords',
            name: 'voiceMail',
            active: this.isAllowed('VoiceMail'),
          },
          {
            text: 'IVR',
            icon: 'bi bi-soundwave',
            url: '/main/ivrRecords',
            name: 'ivr',
            active: this.isAllowed('IVR'),
          },
          {
            text: 'E-mail',
            icon: 'bi bi-envelope-open',
            url: '/main/email/autoEmailRecords',
            name: 'email',
            active: this.isAllowed('Email'),
          },
          {
            text: 'Survey',
            icon: 'bi bi-graph-up-arrow',
            url: '/main/surveyRecords',
            name: 'survey',
            active: this.isAllowed('Survey'),
          },
          {
            text: 'Text',
            icon: 'bi bi-file-text',
            url: '/main/textRecords',
            name: 'text',
            active: this.isAllowed('Text'),
          },
          {
            text: 'Document',
            icon: 'bi bi-file-earmark',
            url: '/main/doc-analytics',
            name: 'document',
            active: this.isAllowed('Document'),
          },
          {
            text: 'Contract',
            icon: 'contract-hand',
            url: '/main/contracts',
            name: 'contract',
            active: this.isAllowed('Contract'),
          },
          {
            text: 'RFP',
            icon: 'contract',
            url: '/main/rfpcontracts',
            name: 'rfpcontract',
            active: this.isAllowed('RFP'),
          },
          {
            text: 'Information Security',
            icon: 'bi-shield-lock',
            url: '/main/infosecurity',
            name: 'infosecurity',
            active: this.isAllowed('InfoSec'),
          },
          {
            text: 'Social Media',
            icon: 'social-media',
            url: '',
            name: 'social-media',
            active: this.isAllowed('SocialMedia'),
          },
        ];

        this.appsListNormal = [
          {
            text: 'AI Assistance',
            icon: 'fa fa-robot',
            url: 'https://gpt.absenceassistance.com',
            name: 'ai-assist',
            active: this.isAllowed('AIAssistance'),
          },
          {
            text: 'BI Reports and Analytics',
            icon: 'custom-report',
            url: 'https://reports.canstringai.com:8443/timebound/#/',
            name: 'reports',
            active: this.isAllowed('Reports'),
          },
        ];
      },
      error: (errors: HttpErrorResponse) => {},
    });

    this.getCompanyLogoData();
    this.settingService.companylogoBS.subscribe((response: any) => {
      if (response.hasOwnProperty('value') && response['value'] == 'logo') {
        this.getCompanyLogoData();
      }
    });
  }
  getCompanyLogoData() {
    const roleId = sessionStorage.getItem('roleId');
    if (roleId === '1' || roleId === '0') {
      this.service.getCompanyLogo().subscribe({
        next: (response: any) => {
          this.caption = response.caption;
          this.title = response.topic;

          if (response['image_url']) {
            this.logoData = true;
            this.loadLogoImageData(response.image_url);
          } else {
            this.logoData = false;
          }
        },
        error: (error: any) => {
          console.log('company logo api error');
        },
      });
    } else {
      return;
    }
  }

  loadLogoImageData(profileName: string) {
    this.service.loadLogoImage(profileName).subscribe({
      next: (blob: Blob) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.logo = reader.result as string;
        };
        reader.readAsDataURL(blob);
      },
      error: (error: any) => {
        console.log('load logo image api error');
        this.logoData = false;
      },
    });
  }

  selectedApps(apps: any) {
    if (apps['name'] == 'ai-assist') {
      window.open('https://gpt.absenceassistance.com', 'target=_blank');
      return;
    }
    if (apps['name'] == 'reports') {
      window.open(
        'https://reports.canstringai.com:8443/timebound/#/',
        'target=_blank',
      );
      return;
    }
    if (apps['name'] === 'social-media') {
      return;
    }
    localStorage.setItem('selectedApps', apps['name']);
    this.selectedApp = apps['name'];
    this.mainService.selectedAppsBS.next(apps);
  }

  isAllowed(appName: string) {
    if (this.allowedApps.length > 0) {
      let index = this.allowedApps.findIndex(
        (list: any) => list['name'].toLowerCase() == appName.toLowerCase(),
      );
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  ngAfterViewInit() {
    this.selectedApp = '';
    setTimeout(() => {
      this.selectedApp = localStorage.getItem('selectedApps');
    }, 0);
  }
}
